import { CSSObject } from "@emotion/react";

export const useStyles = (stretchSearch?: boolean) =>
  ({
    searchInputSpan: {
      width: "246px",

      "@media(max-width: 839px)": {
        width: stretchSearch ? "100%" : "unset",
      },
    },
    inputField: {
      width: "246px",

      "@media(max-width: 1439px)": {
        width: "100%",
      },
    },
  } as CSSObject);
